import { yupResolver } from '@hookform/resolvers/yup';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Autocomplete, Box, Button, Card, Chip, CircularProgress, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, Modal, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import SnackBarUI from '../../comman/SnackBarUI';
import { createQuestionAnswerAction } from '../../redux/toolkit/question-answer/createQuestionAnswer';
import { getAllQuestionAnswerAction } from '../../redux/toolkit/question-answer/getAllQuestionAnswer';
// import { getSubCategoryAction } from '../../redux/toolkit/sub-category/getSubCategory';
import { uplodImageAction } from '../../redux/toolkit/image/uplodImage';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
// import { getValue } from '@testing-library/user-event/dist/utils';
import {supportDataAction} from '../../redux/toolkit/support/list'
import { updateSupportDataAction } from '../../redux/toolkit/support/updataData';
import { singleSupportDataAction } from '../../redux/toolkit/support/singleData';




// schema
const qns_ans_schema = yup.object({
    // cat_name: yup.string().required('Category is required.'),
}).required();


export default function UpdateSupport({state,setState }) {

    // const input = {
    //     option: "",
    // }
    // state
    // const createQns = useSelector(state => state.createQuestionAnswer)
    // let { status, message, loading } = createQns
    const singleSupport = useSelector(state => state.singleSupport)
    const { data:singleSupportData} = singleSupport
    const {loading,message,status}=useSelector(state=>state.updateSupport)
    const {answers,title}=singleSupportData
    // const updateSupport = useSelector(state => state.updateSupport)
    // const { data: getSubCatData } = updateSupport

    const [snack, setSnack] = useState(false)
    const [ansArr, setAnsArr] = useState(answers)
    const [answerOption, setAnswerOption] = useState()
    const [correct_answer, setCorrect_answer] = useState([])
    const [correctAnswerSelect, setCorrectAnswerSelect] = useState({})
    const [file, setFile] = useState('')
    const [fileLoader, setFileLoader] = useState(false)
    const [answerData, setAnswerData] = useState(false)
    const [timeDuration, setTimeDuration] = useState("")
    // const [questionType,setQuestionType]=useState('')
    const { register, setValue, setError, watch, handleSubmit, formState: { errors }, reset } = useForm({ resolver: yupResolver(qns_ans_schema),
        defaultValues:{
            title:title
    } 
});
  
// setValue("title",title)

    const dispatch = useDispatch()
    


    // fn
    const changeOptInput = (e) => {
        setAnswerOption(e.target.value)
    }


    const handleDelAnsOpt = (i) => {

        const tempArr = JSON.parse(JSON.stringify(ansArr));
        tempArr.splice(i, 1)

        
       
        // setAnsArr((current) => current.filter((index) => { return index !== i; }))
        setAnsArr([...tempArr])
        setAnswerOption('')
        
      }

    const handleQns = async (data) => {
        data.id=singleSupportData._id
        
        const createQnsDataAction = await dispatch(updateSupportDataAction({ answers: ansArr,...data }))
        if (createQnsDataAction?.payload?.status === 200) {
            await dispatch(supportDataAction({ is_deleted: false, }))
        }
        setAnsArr([])
        setSnack(true)
        setState(false)
        reset()
    }

    const addAnswerArray = (e) => {
        
        setAnsArr(currentArr=>[...currentArr,answerOption])
        setAnswerOption("")

    }



    const handleClose = function () {
        setAnsArr([])
        setState(false)
    }

    
    // useEffect(() => {
    //     let defaultValues = {};
    //     defaultValues.title = title;
    //     setAnsArr(answers)
    //     reset({ ...defaultValues });
    // }, [data])

    // useEffect(()=>{
    //     dispatch(singleSupportDataAction(cat_id))
    // })

    useEffect(() => {
        setAnsArr(answers)
    }, [])

    return (
        <>
            <Modal sx={{ overflow: 'scroll' }} open={state} onClose={handleClose}>
                <Box className='modal_box'>
                    <Card sx={{ width: 500, p: 5 }}>
                        <Typography variant='h5' sx={{ mb: 5 }} align='center'>Create Support Knowledge</Typography>
                        <form onSubmit={handleSubmit(handleQns)}>
                            <Stack spacing={3}>

                                <TextField label="Title" variant="outlined" placeholder='Title' {...register('title')} error={errors?.title?.message} helperText={errors?.title?.message} />
                                <Grid container columnSpacing={1}>
                                    <Grid item xs={8}>
                                        <TextField id="option" value={answerOption} onChange={(e) => { changeOptInput(e) }} fullWidth label="Answer" variant="outlined" placeholder='Answer' />
                                    </Grid>
                                    <Grid item xs={4}>
                                        {answerOption && <IconButton color='primary'><AddCircleIcon fontSize='large' onClick={addAnswerArray} /></IconButton>}
                                    </Grid>
                                </Grid>

                                <Stack spacing={1}>
                      
                      <TableContainer component={Paper}>
                              <Table  aria-label="simple table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell style={{maxWidth:"10px"}} align="left">sno</TableCell>
                                    <TableCell align="right">Answers</TableCell>
                                    <TableCell align="right">delete</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>

                      {
                          ansArr?.length>0?ansArr?.map((item, index) => {
                          return (
                            
                                  
                                    <TableRow
                                      key={index}
                                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                            
                                      <TableCell align="right">{index+1}</TableCell>
                                      <TableCell align="right" style={{maxWidth:"200px"}}>{item}</TableCell>
                                      <TableCell align="right"><Button onClick={() => handleDelAnsOpt(index)}>delete</Button></TableCell>
                                    </TableRow>
                                  )
                                }):null
                              }
                                </TableBody>
                              </Table>
                            </TableContainer>
                          
                    </Stack>


                                <Stack direction='row' spacing={2}>
                                    <Button variant='contained' type='submit' disabled={loading}>{loading ? <CircularProgress /> : 'Update'}</Button>
                                    <Button variant='contained' color='error' onClick={handleClose}>Close</Button>
                                </Stack>
                            </Stack>
                        </form>
                    </Card>
                </Box>
            </Modal>
           {snack && <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />}
        </>
    )
}



UpdateSupport.propTypes = {
    state: PropTypes.any,
    setState: PropTypes.any
};
